// extracted by mini-css-extract-plugin
export default {"container":"qCMuqG6uK78IMO3KGygX","infoBlock":"kX4OMqkrB6FHGjQKPjA6"};